/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TourIcon from '@mui/icons-material/esm/Slideshow';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const TourButton = (props) => {

	return (
        <Tooltip enterDelay={300} title={<FormattedMessage id="Tooltip.StartTour" defaultMessage="Start Tour" />}>
			<div>
				<IconButton
					onClick={(event) => {
						event.preventDefault();
						props.runTour()
					}}
					size={props.appTour ? "small" : 'large'}
					sx={props.appTour ? {margin: '5px 0px 0px 4px', padding: '5px'} : undefined}
				>
					<TourIcon sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor})` }} />
				</IconButton>
			</div>
		</Tooltip>
    );
}

export default TourButton;
